@if (style() === MarkerStyle.Pin) {
  <div class="pin">
    @if (marker().fields.title || marker().fields.field) {
      <div class="pin-text-container justify-center items-center">
        @let markerTitle = marker().fields.title;
        @if (markerTitle) {
          <div class="pin-title">
            {{
              marker().item
                | dataRowFieldValuePipe: markerTitle.name
                | formatDatasetRow: markerTitle
            }}
          </div>
        }

        @let markerField = marker().fields.field;
        @if (markerField) {
          <div class="pin-field">
            {{
              marker().item
                | dataRowFieldValuePipe: markerField.name
                | formatDatasetRow: markerField
            }}
          </div>
        }
      </div>
    }
    <div>
      <mat-icon class="pin-icon" svgIcon="map-pin" />
    </div>
  </div>
}

@if (style() === MarkerStyle.Bubble) {
  <div class="bubble">
    <div class="pr-4">
      @let imgSrc = image();
      @if (imgSrc) {
        <img
          class="rounded-full w-32 h-32"
          [src]="imgSrc"
          width="32"
          height="32"
          alt=""
          (error)="onImageLoadingError()"
        />
      } @else {
        <mat-icon class="bubble-placeholder-image" svgIcon="image-placeholder" />
      }
    </div>
    @let markerTitle = marker().fields.title;
    @if (markerTitle) {
      <div class="bubble-title">
        {{
          marker().item | dataRowFieldValuePipe: markerTitle.name | formatDatasetRow: markerTitle
        }}
      </div>
    }
    @let markerField = marker().fields.field;
    @if (markerField) {
      <div class="uppercase">
        {{
          marker().item | dataRowFieldValuePipe: markerField.name | formatDatasetRow: markerField
        }}
      </div>
    }
    @let customFields = (marker().fields.customFields$ | async) || [];
    @if (customFields.length > 0) {
      <div class="bubble-additional-fields">
        @for (field of customFields; track field.column) {
          <div>
            {{
              marker().item
                | dataRowFieldValuePipe: field.column ?? ''
                | formatValue
                  : field.displayFormat ?? 'text'
                  : {
                      precision: field.precision,
                      currency: field.currency,
                      durationFormat: field.duration || 'h:mm',
                      dateFormat: field.dateFormat,
                      dateTimeFormat: field.dateTimeFormat,
                    }
            }}
          </div>
        }
      </div>
    }
  </div>
}

@if (style() === MarkerStyle.Image) {
  <div class="image">
    @if (marker().fields.title || marker().fields.field) {
      <div class="image-text-container">
        @let markerTitle = marker().fields.title;
        @if (markerTitle) {
          <div class="image-title">
            {{
              marker().item
                | dataRowFieldValuePipe: markerTitle.name
                | formatDatasetRow: markerTitle
            }}
          </div>
        }
        @let markerField = marker().fields.field;
        @if (markerField) {
          <div class="image-field">
            {{
              marker().item
                | dataRowFieldValuePipe: markerField.name
                | formatDatasetRow: markerField
            }}
          </div>
        }
      </div>
    }
    @let imgSrc = image();
    @if (imgSrc) {
      <img class="image-icon" [src]="imgSrc" alt="Map marker" (error)="onImageLoadingError()" />
    } @else {
      <div class="image-placeholder-image-container">
        <mat-icon class="image-placeholder-image" svgIcon="image-placeholder" />
      </div>
    }
  </div>
}
